import React from 'react';
import styles from './ItemCard.module.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import { ComplaintItem } from '../../../services/complaintsAPI';

interface ItemCardProps {
    item: ComplaintItem;
    onEdit?: (item: ComplaintItem) => void;
    onDelete?: (itemId: string) => void;
    readOnly?: boolean;
    isEditing?: boolean;
}

const ItemCard: React.FC<ItemCardProps> = ({ item, onEdit, onDelete, readOnly = false, isEditing = false }) => {
    const totalReclamados = Object.values(item.quantities).reduce((a: number, b: number) => a + b, 0);
    const isBox = item.productRef === 'CAIXA';
    
    // Labels dinâmicos baseados no tipo de item
    const unitLabel = isBox ? (totalReclamados === 1 ? 'volume' : 'volumes') : (totalReclamados === 1 ? 'par' : 'pares');
    const purchasedUnitLabel = isBox ? 'volumes' : (item.totalPurchased <= 1 ? 'par' : 'pares');

    return (
        <div className={styles.addedItem} style={{ opacity: isEditing ? 0.5 : 1 }}>
            <div className={styles.itemInfo}>
                <h4>{item.productRef} - {item.productDesc}</h4>
                <div className={styles.itemMeta}>
                    {item.ca && <span>C.A: {item.ca} | </span>}
                    {item.batch && <span>Lote: {item.batch} | </span>}
                    Problema: {item.observation || 'N/A'}
                </div>
                {!isBox && (
                    <div className={styles.itemDetails}>
                        <strong>Comprados:</strong> {item.totalPurchased} {purchasedUnitLabel} | <strong>Reclamados:</strong> {totalReclamados} {unitLabel}
                    </div>
                )}
                {isBox && (
                    <div className={styles.itemDetails}>
                        <strong>Quantidade Reclamada:</strong> {totalReclamados} {unitLabel}
                    </div>
                )}
                <div className={styles.itemSizes}>
                    {Object.entries(item.quantities).map(([size, qty]) => (
                        <span key={size} className={styles.sizeBadge}>
                            {size === 'volume' ? `Volume: ${qty}` : `Tam ${size}: ${qty}`}
                        </span>
                    ))}
                </div>
            </div>

            {!readOnly && (
                <div className={styles.itemActions}>
                    {onEdit && (
                        <button
                            className={styles.iconButton}
                            onClick={() => onEdit(item)}
                            title="Editar Item"
                            disabled={isEditing}
                        >
                            <EditIcon fontSize="small" />
                        </button>
                    )}
                    {onDelete && (
                        <button
                            className={`${styles.iconButton} ${styles.deleteButton}`}
                            onClick={() => onDelete(item.id)}
                            title="Remover Item"
                            disabled={isEditing}
                        >
                            <DeleteIcon fontSize="small" />
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default ItemCard;
